import { useDataStore } from '@/stores/dataStore';
import { HeroVoiceBar } from './HeroVoiceBar';
import { HeroUserWidget } from './HeroUserWidget';

/**
 * Bottom sidebar footer — the voice-connected bar + the user/profile row
 * composed into one premium "dock": an inset, rounded, elevated card.
 *
 * The dock's own tone sets it apart from the channel list above; when in
 * voice, the voice row sits above the profile row inside the same card.
 * No drawn lines — tone and spacing separate (owner's no-outline rule).
 */
export function HeroSidebarFooter({ onOpenSettings }: { onOpenSettings: () => void }) {
  const inVoice = useDataStore((s) => !!s.myVoiceChannelId);
  return (
    <div className="studio-sidebar-footer shrink-0 p-2">
      <div className="studio-sidebar-dock overflow-hidden rounded-xl bg-default/40">
        {inVoice && <HeroVoiceBar />}
        <HeroUserWidget onOpenSettings={onOpenSettings} />
      </div>
    </div>
  );
}
